import AddressesDetailsContent from "./AddressesDetailsContent";

export default function AddressesDetailsBody () {
    return (
        <div className="view-qualities folded router-view-container">
         <AddressesDetailsContent/>
      </div>
    )
  }